import React, { Fragment, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { sanitizeHtml } from '../../utils/sanitize';
import { useAlert } from 'react-alert';
import './mock.css';
import './Instruction.css';
import { getExamInstruction } from '../../actions/mockActions';

const Instruction = ({ history }) => {
	const alert = useAlert();
	const dispatch = useDispatch();

	const [checked, setChecked] = useState(false);
	const [examId, setExamId] = useState('');
	const [examName, setExamName] = useState('');
	const [timeDuration, setTimeDuration] = useState(15);

	const { user } = useSelector((state) => state.auth);
	const { instruction } = useSelector((state) => state.mockList);

	useEffect(() => {
		const storedExamId = localStorage.getItem('examId');
		const storedExamName = localStorage.getItem('examName');
		setExamId(storedExamId);
		setExamName(storedExamName);

		if (storedExamId) {
			dispatch(getExamInstruction(storedExamId));
		}
	}, [dispatch]);

	useEffect(() => {
		if (instruction) {
			let duration = 15;
			if (instruction.timeHour !== undefined) {
				duration = Math.floor(instruction.timeHour * 60);
			}
			if (instruction.time !== undefined && instruction.time !== '00') {
				duration = parseInt(duration) + parseInt(instruction.time);
			}
			setTimeDuration(duration);
			localStorage.setItem("timeDuration", duration);
		}
	}, [instruction]);

	const goToPreviousPage = (e) => {
		e.preventDefault();
		history.push('/mode-of-assessment');
	};

	const handleCheck = (e) => {
		setChecked(e.target.checked);
	};

	const submitHandler = (e) => {
		e.preventDefault();
		if (!checked) {
			alert.error("Please agree to the terms");
			return false;
		}
		history.push(`/start-mock/${examId}`);
	};

	return (
		<Fragment>
			<div className="mock-instruction">
				<div className="mock-instruction__inner">
					<ul className="mock-instruction__breadcrumb">
						<li>
							<Link to="/">Home</Link>
						</li>
						<li>
							<Link to="/mode-of-assessment">Mode of Assessment</Link>
						</li>
						<li>Instructions</li>
					</ul>

					<h1 className="mock-instruction__title">Instruction for Candidates</h1>
					<p className="mock-instruction__subtitle">
						Read the guidelines carefully before you begin. The timer starts as soon as you
						launch the mock.
					</p>

					<div className="mock-instruction__card">
						<div className="mock-instruction__candidate">
							<div className="mock-instruction__meta">
								<div className="mock-instruction__meta-item">
									<p className="mock-instruction__meta-label">
										<i className="fas fa-user" /> Name
									</p>
									<p className="mock-instruction__meta-value">
										{user?.first_name} {user?.last_name}
									</p>
								</div>
								<div className="mock-instruction__meta-item">
									<p className="mock-instruction__meta-label">
										<i className="fas fa-graduation-cap" /> Exam
									</p>
									<p className="mock-instruction__meta-value">{examName || '—'}</p>
								</div>
								<div className="mock-instruction__meta-item">
									<p className="mock-instruction__meta-label">
										<i className="fas fa-clock" /> Duration
									</p>
									<p className="mock-instruction__meta-value mock-instruction__meta-value--duration">
										{timeDuration} Minutes
									</p>
								</div>
							</div>
							<div className="mock-instruction__avatar">
								<img
									src={process.env.REACT_APP_PUBLIC_URL + "/assets/img/user.png"}
									alt="User"
								/>
							</div>
						</div>
					</div>

					<div className="mock-instruction__card">
						<div className="mock-instruction__card-head">
							<span className="mock-instruction__card-icon">
								<i className="fas fa-list-ul" />
							</span>
							<div>
								<h2 className="mock-instruction__card-title">Examination Guidelines</h2>
								<p className="mock-instruction__card-subtitle">
									Rules and controls that apply throughout this mock
								</p>
							</div>
						</div>
						{instruction?.examInstructions ? (
							<div
								className="mock-instruction__guidelines"
								dangerouslySetInnerHTML={{
									__html: sanitizeHtml(instruction.examInstructions)
								}}
							/>
						) : (
							<div className="mock-instruction__guidelines mock-instruction__guidelines--empty">
								Instructions for this exam are not available yet.
							</div>
						)}
					</div>

					<label className="mock-instruction__agree">
						<input
							type="checkbox"
							id="exam-instructions"
							className="mock-instruction__checkbox"
							onChange={handleCheck}
							checked={checked}
						/>
						<span className="mock-instruction__agree-text">
							Click here to indicate that you have read and agree to the terms presented in the{' '}
							<a
								className="mock-instruction__agree-link"
								target="_blank"
								href="/pages/terms-conditions"
								rel="noopener noreferrer"
								onClick={(e) => e.stopPropagation()}
							>
								Terms and Conditions agreement
							</a>
						</span>
					</label>

					<div className="mock-instruction__actions">
						<button
							type="button"
							className="mock-instruction__btn mock-instruction__btn--ghost"
							onClick={goToPreviousPage}
						>
							<i className="fas fa-arrow-left" /> Back
						</button>
						<button
							type="submit"
							className={`mock-instruction__btn mock-instruction__btn--green${checked ? '' : ' is-inactive'}`}
							onClick={submitHandler}
						>
							Start Mock <i className="fas fa-arrow-right" />
						</button>
					</div>
				</div>
			</div>
		</Fragment>
	);
};

export default Instruction;
